import React, { useEffect, useState } from 'react';
import AddressGroup from 'app/components/common/AddressGroup';
import useAddress from 'app/hook/common/useAddress';
import { loggingException } from 'app/libs/sentry';
import { FETCH_STATUS } from 'app/constants/common';
import LoadingBar from 'app/components/common/LoadingBar/LoadingBar';
import useEnlog from 'app/hook/common/useEnlog';

function AddressContainer({ onSubmit = undefined }) {
	const { enloggingJsonData } = useEnlog();
	const { address, addressList, currentAddress, isExist, getAddressList, changeAddressValue, resetAddressInfo } = useAddress();
	const [fetchStatus, setFetchStatus] = useState(FETCH_STATUS.IDLE);

	useEffect(
		() => () => {
			resetAddressInfo();
		},
		[resetAddressInfo],
	);

	const handleChange = (e) => {
		const { name, value } = e.target;

		changeAddressValue({ [name]: value });
	};

	const handleSearch = async () => {
		if (address === '') {
			alert('도로명 주소 또는 지번 주소를 입력해 주세요.');
			return;
		}

		try {
			setFetchStatus(FETCH_STATUS.PENDING);

			const { data } = await getAddressList(address);
			let eventName = '결과정상';
			if (data.length === 0) eventName = '결과없음';
			if (data.length > 99) eventName = '결과너무많음';
			const dataTalkCustom = {
				eventtype: 'ACTION',
				eventname: eventName,
				eventnamegroup: '주소검색',
			};
			enloggingJsonData({
				dataTalkCustom,
			});
			changeAddressValue({ currentAddress: address });

			setFetchStatus(FETCH_STATUS.RESOLVED);
		} catch (error) {
			loggingException(error);

			setFetchStatus(FETCH_STATUS.REJECTED);
		}
	};

	const handleSubmit = (buildingCd, postCd, addressValue) => {
		if (onSubmit) {
			onSubmit(buildingCd, postCd, addressValue);
		}
	};

	return (
		<>
			{fetchStatus === FETCH_STATUS.PENDING && <LoadingBar />}
			<AddressGroup
				address={address}
				currentAddress={currentAddress}
				addressList={addressList}
				isExist={isExist}
				onChange={handleChange}
				onSearch={handleSearch}
				onSubmit={handleSubmit}
			/>
		</>
	);
}

export default AddressContainer;
